import React, { useEffect } from 'react';
import { Loader } from '@wix/design-system';
import { getReturnURL } from 'config/client';
import { Background } from 'components/App/Background';
import styles from './RegisterCompletedStep.scss';

const REGISTER_COMPLETED_COOKIE = 'register-completed';

function setRegisterCompletedCookie() {
  document.cookie = `${REGISTER_COMPLETED_COOKIE}=true; path=/`;
}

export function RegisterCompletedStep() {
  const returnURL = getReturnURL();

  useEffect(() => {
    setRegisterCompletedCookie();

    if (!returnURL) {
      return undefined;
    }

    const timer = setTimeout(() => {
      window.location.href = returnURL;
    }, 1000);

    return () => clearTimeout(timer);
  }, [returnURL]);

  return (
    <div className={styles.wrapper}>
      <Background />
      <Loader size="large" />
    </div>
  );
}
